
import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import ContactForm from '@/components/forms/ContactForm.vue'
import VueScrollTo from 'vue-scrollto'

const prospectModule = namespace('prospect')
const contactModule = namespace('contact')

@Component({
  components: {
    BaseCardContainer,
    ContactForm
  }
})
export default class ProspectContactUpdate extends Vue {
  @contactModule.Getter('contactGetter') contact: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @contactModule.Action('getContactByIdAction') getContactById: any
  @contactModule.Action('updateContactAction') updateContact: any

  get relation() {
    return {
      to: 'prospect',
      key: 'ID_PROSPECT',
      value: this.$route.params.id
    }
  }

  mounted() {
    this.getContactById(this.$route.params.contactId)
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  @Watch('$route.params.contactId', {immediate: true, deep: false})
  onUrlChange(newVal: any) {
    this.getContactById(newVal)
  }

  onSubmit(data: any) {
    this.updateContact({
      id: this.$route.params.contactId,
      formParams: data
    }).then(async (data: any) => {
      await this.getProspectById(this.$route.params.id)
      this.$router.push({name: 'prospectContact', params: {id: this.$route.params.id}})
    })
  }

  onCancel() {
    this.$router.push({name: 'prospectContact', params: {id: this.$route.params.id}})
  }
}
